import { GENERIC_ERROR_MESSAGE } from './constants';
import { isErrorWithMessage } from './isErrorWithMessage';

export function getErrorMessage(error: unknown) {
  return isErrorWithMessage(error) ? error.message : GENERIC_ERROR_MESSAGE;
}
